import * as React from 'react';
import styled from 'styled-components'
// import {NavLink} from "react-router-dom";
import {ConstBorderRound, ConstColor, ConstFontStyle} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> {
}

const BadgeNewDefault: React.FC<IProps> = (props) => {

    const { ...SpanProps } = props;

    return (<span {...SpanProps} />)

};

const BadgeNew = styled(BadgeNewDefault)`
    display: inline-block
    padding: 1px 8px;
    border: 1px solid ${ConstColor.Success};
    border-radius: ${ConstBorderRound.CornerRoundAll};
    font-style: normal;
    font-weight: ${ConstFontStyle.ParagraphSup.fontWeight};
    font-size: ${ConstFontStyle.BadgeBorder.fontSize};
    line-height: 15px; // 縦方向中央寄せのためheight と合わせた値
    text-align: center;
    color: ${ConstColor.Success};
`;

export default BadgeNew;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/badge/badge_new.tsx